import { DateTime } from 'luxon';
import { DateControlBase } from '../date-control-base';

// e.g. "okt 2025"
const getMonthLabel = (date: DateTime) => date.setLocale('nl').toFormat('MMM yyyy');

type Props = {
  date: DateTime;
  onChange: (date: DateTime) => void;
  onToday: () => void;
  todayPosition?: 'left' | 'right';
};

export const MonthDateControl = ({ date, onChange, onToday, todayPosition }: Props) => {
  const label = getMonthLabel(date);

  return (
    <DateControlBase
      label={null}
      centerLabel={label}
      onPrev={() => onChange(date.minus({ months: 1 }).startOf('month'))}
      onNext={() => onChange(date.plus({ months: 1 }).startOf('month'))}
      onToday={onToday}
      todayPosition={todayPosition}
    />
  );
};
